import * as React from 'react';
import { observer } from 'mobx-react';
import { ReleaseHeader } from './release-header';
import { ReleaseTracks } from './release-tracks';
import {ArtistSchema, ReleaseSchema, TrackSchema} from '../types/schema';
import {ImagePreloader} from '../types/fn';

export interface ReleaseModel {
  artist: ArtistSchema;
  release: ReleaseSchema;
  tracks: Array<TrackSchema>;
  loading: boolean;
  loadingPage: number;
}

export interface ReleaseProps {
  AddRemove: any;
  PlayButton: any;
  Favourite: any;
  BrandSponsoredLabel: any;
  Loading: any;
  infinite: boolean;
  model: ReleaseModel;
  isMobile: boolean;
  preload: ImagePreloader;
  preloadWaveform: ImagePreloader;
  onClickLink(event: React.MouseEvent<any>): void;
}

export const Release = observer<ReleaseProps>(
  ({ model, infinite, PlayButton, Favourite, AddRemove, BrandSponsoredLabel, Loading, onClickLink, preload, preloadWaveform, isMobile }) => (
    <div>
      <ReleaseHeader
        model={model}
        onClickLink={onClickLink}
        preload={preload}
      />
      <ReleaseTracks
        model={model}
        PlayButton={PlayButton}
        Favourite={Favourite}
        AddRemove={AddRemove}
        BrandSponsoredLabel={BrandSponsoredLabel}
        onClickLink={onClickLink}
        preloadWaveform={preloadWaveform}
        isMobile={isMobile}
      />
    </div>
  )
);